import Nav from '../components/Nav'
import UploadFile from '../components/UploadFile'
import {useState, useEffect} from 'react'
import {useParams} from 'react-router-dom'
import axios from 'axios'
import FormHandler from '../hooks/FormHandler';
import config from '../config';
import {useCookies} from 'react-cookie'
import { reverseSizeMap } from '../utils/sizeUtils';


const OnBoarding = () => {
    const { edit } = useParams();
    const [isValid] = useState(null)
    const [cookies] = useCookies(null)

    const getCurrentUser = async () => {
        try {
            const response = await axios.get(`${config.apiUrl}user`, {
                headers: {"token": localStorage.getItem("token")},
                params: {userId: cookies.UserId}
            })
            const numeric_size = response.data["top_size"]
            const clothing_cut = response.data["clothing_cut"]
            const top_size = reverseSizeMap[clothing_cut][numeric_size]
            setFormData((prevState) => ({
                ...prevState,
                ["shoe_size"]: response.data["shoe_size"],
                ["trouser_size"]: response.data["trouser_size"],
                ["top_size"]: top_size,
                ["clothing_cut"]: clothing_cut,
                ["about"]: response.data["about"],
                ["pic"]: response.data["pic"],
                ["plz"]: response.data["plz"]
            }));
            
        } catch (error) {
            console.log(error)
        }
    }

    const {  formData, setFormData, handleChange, handleFileChange, handleSubmit, getLocations } = FormHandler({
        user_id: cookies.UserId,
        /*
        chest_girth: "",
        arm_length:"",
        inside_length:"",
        leg_length:"",
        waistline_length:"",
        hip_girth:"",
        */
        shoe_size: 32,
        trouser_size: 32,
        top_size: 32,
        clothing_cut: "female",
        about: "",
        pic: "",
        plz: ""
    }, edit, "user");
      
    useEffect(() => {
        async function fetchData(){
            if (edit !== '0'){
                await getCurrentUser();
            }
        }

        getLocations();
        fetchData();
    }, []);
    
    return (
        <>

            <div className="onboarding">
                <h2>{edit ? "Konto bearbeiten" :"Konto erstellen"}</h2>

                <form onSubmit={handleSubmit}>
                    <section>


                        <label>Schnitt</label>
                        <div className="multiple-input-container">
                            <input
                                id="female_clothing_cut"
                                type="radio"
                                name="clothing_cut"
                                value="female"
                                onChange={handleChange}
                                checked={formData.clothing_cut === "female"}
                            />
                            <label htmlFor="female_clothing_cut">Frau</label>
                            <input
                                id="male_clothing_cut"
                                type="radio"
                                name="clothing_cut"
                                value="male"
                                onChange={handleChange}
                                checked={formData.clothing_cut === "male"}
                            />
                            <label htmlFor="male_clothing_cut">Mann</label>
                            <input
                                id="unisex_clothing_type"
                                type="radio"
                                name="clothing_cut"
                                value="unisex"
                                onChange={handleChange}
                                checked={formData.clothing_cut === "unisex"}
                            />
                            <label htmlFor="unisex_clothing_type">Unisex</label>
                            <input
                                id="kid_clothing_cut"
                                type="radio"
                                name="clothing_cut"
                                value="kid"
                                onChange={handleChange}
                                checked={formData.clothing_cut === "kid"}
                            />
                            <label htmlFor="kid_clothing_cut">Kind</label>
                        </div>

                        <label htmlFor="shoe_size">Schuhgrösse (ab 24):</label>

                        <input
                            id="shoe_size"
                            type="number"
                            name="shoe_size"

                            min="24"
                            max="92"
                            step={0.5}
                            value={formData.shoe_size}
                            onChange={handleChange}
                        />

                        <label htmlFor="top_size">Oberteilgrösse:</label>
                        <select
                            id="top_size"
                            name="top_size"
                            value={formData.top_size}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Keine</option>
                            <option value="XXS">XXS</option>
                            <option value="XS">XS</option>
                            <option value="S">S</option>
                            <option value="M">M</option>
                            <option value="L">L</option>
                            <option value="XL">XL</option>
                            <option value="XXL">XXL</option>
                            <option value="XXXL">XXXL</option>
                        </select>

                        <label htmlFor="trouser_size">Hosenbreite (ab 24):</label>

                        <input
                            id="trouser_size"
                            type="number"
                            name="trouser_size"
                            min="24"
                            max="92"
                            step={2}
                            value={formData.trouser_size}
                            onChange={handleChange}
                        />
                        {isValid === null ? (
                        <div></div>
                            ) : isValid ? (
                                <div></div>
                            ) : (
                                <div style={{ color: 'red' }}>Diese Postleitzahl existiert nicht in der Schweiz</div>
                            )}

                        <input type="submit"/>
                    </section>
                    <section>


                        <label htmlFor="plz">Standard-Übergabeort (Postleitzahl)</label>

                        <input
                            id="plz"
                            type="number"
                            name="plz"
                            min="0"
                            value={formData.plz}
                            onChange={handleChange}
                            required
                        />
                        <label htmlFor="about">Über mich</label>
                        <input
                            id="about"
                            type="text"
                            name="about"
                            required={true}
                            placeholder="I like long walks..."
                            value={formData.about}
                            onChange={handleChange}
                        />

                        <UploadFile
                            title={"Profilbild"}
                            file={formData.pic}
                            filetype={"user"}
                            handleFileChange={handleFileChange}
                        />
                    </section>
                </form>
                
            </div>
        </>
    )
}
export default OnBoarding
